import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Link } from 'react-router-dom';

import { rem } from '../../core';

const modifiers = {
  wBorder: () => ({
    styles: `
      border-radius: 0.25rem;
      border: solid 1px #c4cdd5;
    `,
  }),
  wShadow: () => ({
    styles: `
      border-radius: 0.25rem;
      padding: 0;
      // TODO: Create mixin
      box-shadow: 0 ${rem(2)} ${rem(20)} rgba(216, 216, 216, .67);
    `,
  }),
  active: () => ({
    styles: `
      border-radius: 0.25rem;
      border: solid 1px #637381;
    `,
  }),
};

const commonStyle = `
  width: 100%;
  max-width: 68.438rem;
  padding: 0.5rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const CardLinkStyled = styled(Link).attrs({
  className: 'component__card',
})`
  ${commonStyle}
  ${applyStyleModifiers(modifiers)};
`;

export const CardStyled = styled.div.attrs({
  className: 'component__card',
})`
  ${commonStyle}
  ${applyStyleModifiers(modifiers)};
`;
